module.exports = __webpack_public_path__ + "img/1530879936.d24202fe.jpg";